<ion-content>
    @if (purchaseDetail$ | async; as purchaseDetail) {
    <div class="store-payment-wrapper">
        @if (stepperIndex == 0) {
        <div class="store-payment-top">
            <img src="assets/icon/back_arrow.png" alt="Back arrow" class="back-ic" (click)="handleExitIntentPopup()" />
            <h1 class="checkout-heading">{{ "add-card.Checkout" | translate }}</h1>
        </div>
        
        <div class="error-message">
            <div class="error-icon">!</div>
            <div class="error-text">
                <div class="error-title">{{ "checkout_try_again.wrong" | translate }}</div>
                <div class="error-subtitle">{{ "checkout_try_again.try-again" | translate}}</div>
            </div>
        </div>
        }
        @if (stepperIndex == 1) {
        <div class="store-summary-top">
            <h1 class="checkout-heading">{{ "add-card.confimation" | translate }}</h1>
        </div>
        }
        <mat-horizontal-stepper labelPosition="bottom" [selectedIndex]="stepperIndex" #stepper
            class="payment-stepper store-checkout-payment" [linear]="true">
            <mat-step [completed]="isPaymentDone">
                <ng-template matStepLabel>{{ "add-card.Payment" | translate }}</ng-template>
                <app-purchase-detail-card [purchaseDetail]="purchaseDetail" [checkoutDescription]="checkout_description"
                    [customOfferCashbackText]="customOfferCashbackText" [selectedLanguage]="selectedLanguage"
                    [displayMode]="'payment'" [selectedDiscountValue]="selectedDiscountValue"
                    [updatedPrizeValue]="updatedPrizeValue" [currencySymbol]="currencySymbol"
                    [preferredCurrency]="preferredCurrency" [upsellSummaryArray]="upsellSummaryArray">
                </app-purchase-detail-card>
                <!-- [UI] Update Addons Section start -->
                @if (upsellList && purchaseDetail?.offers?.p_type === 21) {
                <app-upsell-addons [upsellList]="upsellList" [preferredCurrency]="preferredCurrency"
                    [currencySymbol]="currencySymbol" [selectedLanguage]="selectedLanguage"
                    (addonChanged)="onAddonChanged($event)">
                </app-upsell-addons>
                }
                <!-- [UI] Update Addons Section end -->
                <!-- [UI] vouchers slider -->
                @if (discountVouchersStatus && discountVouchersData && (discountVouchersData?.length > 0) &&
                !cardTokenizedCalled && !paymentFailRedirectionStatus) {
                <app-vouchers-slider 
                    [vouchers]="discountVouchersData"
                    [sliderOptions]="storeSliderOptions1"
                    (voucherSelected)="onVoucherSelected($event ,voucher, triggerType)">
                </app-vouchers-slider>
                }
                <!-- [UI] vouchers slider -->
                <div class="payable-today-wrapper">
                    <p class="payable-today">{{ "add-card.Payable today" | translate }}</p>
                    @if (purchaseDetail?.selectedDiscount) {
                    <div>
                    @if (purchaseDetail?.selectedDiscount?.type !== 'subscription') {
                    <p class="payable-today-amt">
                        <span [ngClass]="{'strikethrough-grayed': selectedDiscountValue > 0}"> {{ currencySymbol
                             }}{{
                                (purchaseDetail?.offers?.int_price ?
                            purchaseDetail?.offers?.int_price[preferredCurrency] :
                                purchaseDetail?.prize + (updatedPrizeValue || 0)) | displayCurrency }}</span> 
                        @if (selectedDiscountValue > 0) {
                        <span>{{ currencySymbol }}{{
                                ((purchaseDetail?.offers?.int_price ?
                                purchaseDetail?.offers?.int_price[preferredCurrency] :
                                purchaseDetail?.prize +
                                (updatedPrizeValue || 0)) - ((purchaseDetail?.offers?.int_price ?
                                purchaseDetail?.offers?.int_price[preferredCurrency]
                                : purchaseDetail?.prize + (updatedPrizeValue || 0)) *
                    selectedDiscountValue)) | displayCurrency }}
                        </span>
                            }
                        </p>
                        }
                        @if (purchaseDetail?.selectedDiscount?.type == 'subscription') {
                        <p class="payable-today-amt">
                            {{ currencySymbol }}{{ ((purchaseDetail?.offers?.int_price ?
                            purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize +
                            (updatedPrizeValue || 0)) -
                            ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] :
                            purchaseDetail?.prize + (updatedPrizeValue || 0)) * selectedDiscountValue)) | displayCurrency }}/wk
                        </p>
                        }
                    </div>
                    } @else {
                    <div>
                        @if (purchaseDetail?.page !== 'offerOfDay') {
                        <p class="payable-today-amt">
                            {{ currencySymbol }}{{ ((purchaseDetail?.offers?.int_price ?
                            purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize +
                            (updatedPrizeValue || 0)) -
                            ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] :
                            purchaseDetail?.prize + (updatedPrizeValue || 0)) * selectedDiscountValue)) | displayCurrency }}
                        </p>
                        }
                        @if (purchaseDetail?.page === 'offerOfDay') {
                        <p class="payable-today-amt">
                            {{ currencySymbol }}{{ ((purchaseDetail?.offers?.int_price ?
                            purchaseDetail?.offers?.int_price[preferredCurrency] : purchaseDetail?.prize +
                            (updatedPrizeValue || 0)) -
                            ((purchaseDetail?.offers?.int_price ? purchaseDetail?.offers?.int_price[preferredCurrency] :
                            purchaseDetail?.prize + (updatedPrizeValue || 0)) * selectedDiscountValue)) | displayCurrency }}/wk
                        </p>
                        }
                    </div>
                    }
                </div>
                @if (isPaymill) {
                <div style="
                    padding: 0.3vh;
                    border-radius: 2vh;
                    min-height: 25vh;
                    width: 97%;
                    margin-left: 1.5%;
                    margin-top: 1vh;
                    height: auto;
                ">
                    <div class="timer">
                        <div class="d-flex">
                            <img src="../../../assets/icon/lock key.png" alt="" class="lock" />
                            <p>{{ "add-card.Secure" | translate }}</p>
                        </div>
                        <div>{{ "add-card.time_left" | translate }}: <span #timer></span></div>
                    </div>
                    <div style="visibility: hidden" [ngClass]="isPaymentDone ? 'show' : 'hide'">
                        @defer () {
                        <iframe style="border: 0; width: 100%; height: 100vh; padding: 1vh" #iframe id="myCustomIframe1"
                            name="myCustomIframe1" (load)="load(iframe, stepper)"
                            sandbox="allow-forms allow-modals allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-top-navigation">
                        </iframe>
                        }
                    </div>
                    @if (!isPaymentDone) {
                    <div>
                        <div style="position: absolute; width: 92%; text-align: center">
                            @if (addNewCardInProgress) {
                            <ion-spinner name="lines-small" diameter="40" style="color: green; margin-top: 4vh">
                            </ion-spinner>
                            }
                        </div>
                        <form action="{{ origin + '/r' }}" class="paymentWidgets" data-brands="VISA MASTER"></form>
                    </div>
                    }
                </div>
                }
                @if (isCheckoutCom) {
                <div style="
                    padding: 0.3vh;
                    border-radius: 2vh;
                    min-height: 25vh;
                    width: 97%;
                    margin-left: 1.5%;
                    margin-top: 1vh;
                    height: auto;
                    position: relative;
                    background-color: transparent;
                " class="checkout_gateway">
                    @if (isCheckoutComform) {
                    <form id="payment-form" (submit)="onSubmit($event)">
                        <ng-container>
                            <div class="one-liner flow-entry">
                                <div id="cko-flow-container" class="cko-flow-container"></div>
                            </div>
                            @if (errorMessage) {
                            <div class="message">
                                @if (isCheckoutLoadingMessage(errorMessage) && showCheckOutComSpinner && !checkoutFlowReady) {
                                <ion-spinner name="lines-small" class="checkout-inline-spinner"></ion-spinner>
                                }
                                <p [ngClass]="isCheckoutLoadingMessage(errorMessage) ? 'loading-message' : 'error-message'">{{ errorMessage }}</p>
                            </div>
                            }
                        </ng-container>
                    </form>
                    }
                    @defer (when redirectlink) {
                    <iframe
                        [ngStyle]="{ 'height': isCheckoutComform ? '0vh' : '100vh', 'pointer-events': isCheckoutComform ? 'none' : 'auto' }"
                        style="border: 0; width: 100%; padding: 1vh;"
                        id="checkoutAuthorizationIframe"
                        name="checkoutAuthorizationIframe"
                        [src]="redirectlink"
                        #checkOutIframe>
                    </iframe>
                    }
                </div>
                }
                <p class="text-button" (click)="handleExitIntentPopup()">{{ "payment.No" | translate }}</p>
                <p class="disclaimer-text">
                    {{'payment.Hatchster'|translate}}
                </p>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel> {{ "add-card.Summary" | translate }}</ng-template>
                <div class="checkout-summary">
                    <ion-card class="brought-card">
                        <p class="brought-card-heading">{{ "add-card.bought" | translate }}</p>
                        <div class="brought-card-content-wrap">
                            <app-purchase-detail-card [purchaseDetail]="purchaseDetail"
                                [checkoutDescription]="checkout_description"
                                [customOfferCashbackText]="customOfferCashbackText"
                                [selectedLanguage]="selectedLanguage" [displayMode]="'summary'"
                                [selectedDiscountValue]="selectedDiscountValue" [updatedPrizeValue]="updatedPrizeValue"
                                [currencySymbol]="currencySymbol" [preferredCurrency]="preferredCurrency"
                                [upsellSummaryArray]="upsellSummaryArray">
                            </app-purchase-detail-card>
                            <ion-row class="card-price-wrap">
                                <ion-col>
                                    <p class="card-price">{{ "add-card.Price" | translate }}</p>
                                </ion-col>
                                <ion-col class="card-price-value-wrap">
                                    @if (purchaseDetail?.selectedDiscount) {
                                    <div>
                                        @if (purchaseDetail?.selectedDiscount?.type !== 'subscription') {
                                        <p class="card-price-value">
                                            <span [ngClass]="{'strikethrough-grayed': selectedDiscountValue > 0}"> {{
                                                currencySymbol }}{{
                                                (purchaseDetail?.offers?.price +
                                                (updatedPrizeValue || 0)) | displayCurrency }}</span> @if
                                            (selectedDiscountValue > 0) {
                                            <span>{{ currencySymbol }}{{
                                                ((purchaseDetail?.offers?.price + (updatedPrizeValue || 0)) -
                                                ((purchaseDetail?.offers?.price +
                                                (updatedPrizeValue || 0)) *
                                                selectedDiscountValue)) | displayCurrency }}</span>
                                            }
                                        </p>
                                        }
                                        @if (purchaseDetail?.selectedDiscount?.type == 'subscription') {
                                        <p class="card-price-value">
                                            {{ currencySymbol }}{{ (purchaseDetail?.offers?.price + (updatedPrizeValue
                                            || 0)) |
                                            displayCurrency }}/wk
                                        </p>
                                        }
                                    </div>
                                    } @else {
                                    <div>
                                        @if (purchaseDetail?.page !== 'offerOfDay') {
                                        <p class="card-price-value">
                                            {{ currencySymbol }}{{ (purchaseDetail?.prize + (updatedPrizeValue || 0)) |
                                            displayCurrency }}
                                        </p>
                                        }
                                        @if (purchaseDetail?.page === 'offerOfDay') {
                                        <p class="card-price-value">
                                            {{ currencySymbol }}{{ (purchaseDetail?.prize + (updatedPrizeValue || 0)) |
                                            displayCurrency
                                            }}/wk
                                        </p>
                                        }
                                    </div>
                                    }
                                </ion-col>
                            </ion-row>
                        </div>
                        @if (purchaseDetail?.draw) {
                        <ion-row class="start-day-wrapper">
                            <ion-col>
                                <p class="start-date">{{ "add-card.Start date" | translate }}</p>
                            </ion-col>
                            <ion-col class="start-day-wrap">
                                <p class="start-day">{{ ('dynamic_value.'+(purchaseDetail?.draw | day) | translate) }}
                                </p>
                            </ion-col>
                        </ion-row>
                        }
                    </ion-card>
                    <ion-button class="view-ticket-btn" (click)="fetchSyndicateAndShowTicket()"
                        [disabled]="addNewCardInProgress">
                        @if (addNewCardInProgress) {
                        <ion-spinner name="lines-small" class="sign-in-spinner" duration="2000"
                            style="color: white; margin-right: 1vh"></ion-spinner>
                        }
                        @if (purchaseDetail.page == 'topUp' && !addNewCardInProgress) {
                        <span>{{ "add-card.Back to store" |
                            translate }}
                        </span>
                        }
                        @if (purchaseDetail.page != 'topUp' && !addNewCardInProgress) {
                        <span>{{
                            "add-card.View ticket" | translate
                            }}</span>
                        }
                    </ion-button>
                </div>
            </mat-step>
            <ng-template matStepperIcon="edit">
                <mat-icon>{{'add-card.Done'|translate}}</mat-icon>
            </ng-template>
        </mat-horizontal-stepper>
        @if (stepperIndex == 1) {
        <app-confirmation-promotions [promotions]="promotions" [processingStates]="processingStates"
            [expiryMinutes]="expiry_in_minutes" [seconds]="seconds" (offerPayment)="onOfferPayment($event)">
        </app-confirmation-promotions>
        }
    </div>
    } @else {
    <app-in-progress-animation></app-in-progress-animation>
    }
</ion-content>

<ng-template #loading>
    <app-in-progress-animation></app-in-progress-animation>
</ng-template>
